// Funkcie pre logaritmické škálovanie (prevzaté z InvestmentSlider)
export type DynamicStepRule = {
  threshold: number
  multiplier: number
}

export const valueToSliderPosition = (
  value: number,
  min: number,
  max: number
): number => {
  const minLog = Math.log(min)
  const maxLog = Math.log(max)
  const valueLog = Math.log(value)

  return ((valueLog - minLog) / (maxLog - minLog)) * 100
}

export const sliderPositionToValue = (
  position: number,
  min: number,
  max: number
): number => {
  const minLog = Math.log(min)
  const maxLog = Math.log(max)

  const normalizedPosition = position / 100
  const valueLog = minLog + normalizedPosition * (maxLog - minLog)

  return Math.exp(valueLog)
}

// Defaultné pravidlá pre dynamické kroky (ako v InvestmentSlider)
export const DEFAULT_DYNAMIC_STEP_RULES: DynamicStepRule[] = [
  { threshold: 200, multiplier: 1 },
  { threshold: 500, multiplier: 2 },
  { threshold: 2000, multiplier: 5 },
  { threshold: Infinity, multiplier: 5 },
]

export const getDynamicStep = (
  value: number,
  baseStep: number,
  rules: DynamicStepRule[] = DEFAULT_DYNAMIC_STEP_RULES
): number => {
  for (const rule of rules) {
    if (value < rule.threshold) {
      return baseStep * rule.multiplier
    }
  }
  // Fallback na posledné pravidlo
  return baseStep * rules[rules.length - 1].multiplier
}

export const roundToStep = (
  value: number,
  step: number,
  min: number,
  max: number
): number => {
  const rounded = Math.round(value / step) * step
  return Math.max(min, Math.min(max, rounded))
}
